/**
 * useMetaPixel - Hook para Zenviq
 *
 * Carga el Pixel de Meta y dispara eventos en paralelo al CAPI server-side
 * (FastAPI) usando el mismo event_id para deduplicación.
 *
 * Variables de entorno necesarias (CRA):
 *   REACT_APP_META_PIXEL_ID
 *   REACT_APP_API_URL
 */

import { useCallback, useEffect } from 'react';

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Genera UUID v4 para event_id (deduplicación pixel <-> CAPI)
function generateEventId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function useMetaPixel() {
  // Cargar pixel script al montar (solo 1 vez en toda la app)
  useEffect(() => {
    if (!PIXEL_ID || window.fbq) return;

    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js'
    );
    /* eslint-enable */

    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);

  /**
   * Dispara evento al Pixel browser Y al CAPI server-side con mismo event_id.
   * Meta deduplica automáticamente.
   */
  const trackEvent = useCallback(async (eventName, data = {}) => {
    const eventId = generateEventId();

    // 1. Pixel browser
    if (window.fbq) {
      const customData = {};
      if (data.value !== undefined) {
        customData.value = data.value;
        customData.currency = data.currency || 'USD';
      }
      window.fbq('track', eventName, customData, { eventID: eventId });
    }

    // 2. CAPI server-side (mismo event_id para deduplicación)
    if (!API_URL) return;

    try {
      await fetch(`${API_URL}/meta/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          event_name: eventName,
          event_id: eventId,
          email: data.email,
          user_id: data.user_id,
          first_name: data.first_name,
          last_name: data.last_name,
          value: data.value,
          currency: data.currency || 'USD',
          event_source_url: window.location.href,
        }),
      });
    } catch (error) {
      console.warn('CAPI tracking failed:', error);
    }
  }, []);

  return { trackEvent };
}